let initPrevState:any = {
    list: [],
    playIndex: 0,
};

export const LOAD_LIST = "LOAD_LIST";
export const CLEAR_LIST = "CLEAR_LIST";

export function playlist (prevState:any = initPrevState, action:any){
    if (action.type == LOAD_LIST){

        return {
            list: [...action.list],
            playIndex: 0
        };
        let old = [...prevState.list];
        let old2 = [...prevState.list];

        let newAudioLists = old.concat(action.list.filter(function (audio:any, i:number) {
            return old2.findIndex(function (v) {
              return v.musicSrc === audio.musicSrc;
            }) === -1;
          }));
          
        return {
            list: [...newAudioLists],
            playIndex: newAudioLists.length - 1
        };
    } else if (action.type == CLEAR_LIST){
        return initPrevState;
    } 

    return prevState;
}